module.exports = __webpack_public_path__ + "img/pdf-file-icon.ede71849.svg";